import {AgentView, MerchantView} from '@ozark/common';
export const hasResidualsPermissions = (authProfile: AgentView | MerchantView | undefined) => {
  return !!authProfile?.permissions?.residuals;
};
